import React from "react";
import Typewriter from "typewriter-effect";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectFade, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-fade";
import images1 from "../assets/img/bg8.jpg";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

// Define TypeScript type for slider data
interface SliderData {
  id: number;
  bg: string;
  btnNext: string;
}

const sliderData: SliderData[] = [
  {
    id: 1,
    bg: images1,
    btnNext: "See our products",
  },
];

const Header = () => {
  return (
    <>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <Swiper
          modules={[EffectFade, Autoplay]}
          effect="fade"
          loop={true}
          autoplay={{ delay: 3000, disableOnInteraction: false }}
          className="heroSlider h-[700px]"
        >
          {sliderData.map(({ id, bg, btnNext }) => (
            <SwiperSlide
              className="h-full relative flex justify-center items-center"
              key={id}
            >
              {/* Text content with black background */}
              <div className="z-50 relative pt-16 sm:pt-10 flex flex-col justify-center h-full px-4 sm:px-6 md:px-8 items-center">
                <div className="bg-black/70 p-2 rounded-lg text-white max-w-[90%] md:max-w-[70%] text-center">
                  <h1 className="text-[1rem] sm:text-[1.2rem] font-semibold mb-1 italic">
                    Rehoboth Standard International Limited
                  </h1>
                  <h2 className="mt-4 text-2xl md:text-4xl sm:text-[0.9rem]">
                    Appointed Distributor of Nigerchin Wires and Cables.
                  </h2>

                  <h1 className="text-[1rem] md:text-[1.2rem] mt-4 text-gray-50">
                    <Typewriter
                      options={{
                        strings: [
                          "Power Your Project with Precision.",
                          "One Cable at a Time",
                          "From Order to Connection",
                        ],
                        autoStart: true,
                        loop: true,
                        deleteSpeed: 30,
                        delay: 70,
                      }}
                    />
                  </h1>
                </div>

                {/* Buttons (Outside the black blur) */}
                <div className="w-full flex flex-col items-center gap-4 mt-6 sm:mt-8">
                  <Link to={"/products"}>
                    <button
                      type="submit"
                      className="py-2 sm:py-[1rem] bg-gray-700 hover:bg-blue-600 transition text-white px-5 sm:px-6 rounded-3xl"
                    >
                      Get a Quote
                    </button>
                  </Link>

                  <a
                    href="/NigerChin.pdf"
                    download="NigerChin.pdf"
                    className="bg-primary text-white px-3 py-2 md:py-3 rounded-lg font-semibold shadow-md hover:bg-primary-dark transition text-[0.9rem] md:text-base"
                  >
                    Download Product Catalogue
                  </a>
                </div>
              </div>

              {/* Background Image */}
              <div className="absolute top-0 w-full h-full">
                <img
                  className="object-cover h-full w-full"
                  src={bg}
                  alt="Slide"
                />
              </div>

              {/* Overlay */}
              <div className="absolute w-full top-0 h-full bg-black/30 z-10" />
            </SwiperSlide>
          ))}
        </Swiper>
      </motion.div>
    </>
  );
};

export default Header;
